
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "PlayPause170508545",
      {"classes":{"root":"PlayPause170508545__root","button":"PlayPause170508545__button","disabled":"PlayPause170508545__disabled"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  